import { NgModule } from '@angular/core';

import { BaseModule } from '../shared/base.module';
import { SelfEvaluationRoutesModule } from './self-evaluation.routes';
import { FeelingsRatingComponent } from './feelings-rating/feelings-rating.component';
import { SelfEvaluationComponent } from './self-evaluation.component';
import { FeelingComponent } from './feelings-rating/feeling/feeling.component';
import { FeelingsSelectionComponent } from './feelings-selection/feeling-selection.component';
import { SmokeDetectorComponent } from './smoke-detector/smoke-detector.component';
import { AmnesticFeelingSelectionComponent } from './amnestic-feeling-selection/amnestic-feeling-selection.component';
import { AmnesticSmokeDetectorComponent } from './amnestic-smoke-detector/amnestic-smoke-detector.component';
import { ContinueLaterComponent } from './continue-later/continue-later.component';

import { SelfEvaluationService } from './self-evaluation.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SelfEvaluationProgressbarComponent } from './shared/self-evaluation-progressbar/self-evaluation-progressbar.component';
import { SelfEvaluationConfirmModalComponent } from './shared/self-evaluation-confirm-modal/self-evaluation-confirm-modal.component';
import { DialogModule } from '../dialog/dialog.module';
import { CircumstanceComponent } from './circumstance/circumstance.component';
import { MatSliderModule } from '@angular/material/slider';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
    imports: [
        BaseModule,
        SelfEvaluationRoutesModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        DialogModule,
        MatSliderModule
    ],
    declarations: [
        SelfEvaluationComponent,
        FeelingsRatingComponent,
        FeelingComponent,
        FeelingsSelectionComponent,
        SmokeDetectorComponent,
        CircumstanceComponent,
        AmnesticFeelingSelectionComponent,
        AmnesticSmokeDetectorComponent,
        ContinueLaterComponent,
        SelfEvaluationProgressbarComponent,
        SelfEvaluationConfirmModalComponent,
    ],
    providers: [
        SelfEvaluationService
    ]
})
export class SelfEvaluationModule {
}
